import { useEffect } from "react";

const useRouteChange = (callback) => {
	useEffect(() => {
		const handleRouteChange = () => {
			callback(window.location.pathname);
		};

		const originalPushState = window.history.pushState;
		const originalReplaceState = window.history.replaceState;

		window.history.pushState = (...args) => {
			originalPushState.apply(window.history, args);
			handleRouteChange();
		};

		window.history.replaceState = (...args) => {
			originalReplaceState.apply(window.history, args);
			handleRouteChange();
		};

		window.addEventListener("popstate", handleRouteChange);

		return () => {
			window.history.pushState = originalPushState;
			window.history.replaceState = originalReplaceState;
			window.removeEventListener("popstate", handleRouteChange);
		};
	}, [callback]);
};

export default useRouteChange;
